import type { InferResponseType } from 'hono'
import { getAuthHeaders } from '@/app/auth/getAuthHeaders'
import { client } from '@/shared/api/client'
import { readAvatarApiErrorBody } from './response'

export type AvatarGetResponse = {
  vroidHubCharacterModelId?: string | null
  avatarVersion: string
  displayName: string | null
  source: 'vroid_hub' | 'upload'
}

const { $get } = client.api.avatar
type ApiAvatarGetResponse = Extract<
  InferResponseType<typeof $get>,
  { avatarVersion: string; displayName: string | null; source: string }
>

export const getAvatar = async (): Promise<AvatarGetResponse | null> => {
  const header = await getAuthHeaders()
  const response = await client.api.avatar.$get({ header })

  if (response.status === 204) {
    return null
  }

  if (!response.ok) {
    const body = await readAvatarApiErrorBody(response)
    throw Object.assign(new Error('アバター設定の取得に失敗しました。'), {
      status: response.status,
      code: body?.code ?? 'REQUEST_FAILED',
    })
  }

  return (await response.json()) as ApiAvatarGetResponse
}
